module.exports = __webpack_public_path__ + "static/media/institucionalPoster.29e011c4.png";